import { GUEST_USER_PREVALAGES } from "../actionTypes";

const initialState = {
    guestUserPrevalages: {}
};

const guestUserReducer = (state = initialState, actions) => {
    switch (actions?.type) {
        case GUEST_USER_PREVALAGES?.UPDATE_GUEST_USER_PREVALAGES_SUCCESS:
            return {
                ...state,
                guestUserPrevalages: actions?.payload
            };
        case GUEST_USER_PREVALAGES?.UPDATE_GUEST_USER_PREVALAGES_FAILURE:
            return {
                ...state,
                guestUserPrevalages: actions?.payload
            };
        default:
            return state;
    }
};


export default guestUserReducer;